import {
  SET_CHANNEL,
  SET_CHANNEL_HISTORY,
  RESET_MESSAGE_STATUS,
  RESET_CHAT,
  SET_CONNECTION,
  CHAT_OPEN,
} from "./actionsTypes";
import {
  getChannelsService,
  getChannelHistoryService,
  readMessageService,
} from "../service";
import { setFetching, setError } from "../../../request/actions/requestActions";

const setChannel = (data) => ({
  type: SET_CHANNEL,
  payload: data,
});

const setChannelHistory = (data) => ({
  type: SET_CHANNEL_HISTORY,
  payload: data,
});

export const resetMessageStatus = () => ({
  type: RESET_MESSAGE_STATUS,
});

export const resetChat = () => ({
  type: RESET_CHAT,
});

export const setConnection = (data) => ({
  type: SET_CONNECTION,
  payload: data,
});

export const handleChatOpen = (bool) => ({
  type: CHAT_OPEN,
  payload: bool,
});

export const asyncGetChannel = () => async (dispatch) => {
  dispatch(setFetching({ isFetching: true }));
  try {
    const response = await getChannelsService();
    if (response.data.data?.length > 0) {
      dispatch(setChannel(response.data.data.slice(0, 1).shift()));
    }
  } catch (error) {
    let message = "";
    if (error?.response?.data) {
      message = error.response.data.errors.length
        ? error.response.data.errors.toString()
        : error.response.data.warnings.toString();
    } else message = "Unexpected error";

    dispatch(setError({ isOpen: true, message, type: "error" }));
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};

export const asyncGetChannelHistory = (channelId) => async (dispatch) => {
  dispatch(setFetching({ isFetching: true }));
  try {
    const response = await getChannelHistoryService(channelId);
    dispatch(setChannelHistory(response.data?.data));
  } catch (error) {
    let message = "";
    if (error?.response?.data) {
      message = error.response.data.errors.length
        ? error.response.data.errors.toString()
        : error.response.data.warnings.toString();
    } else message = "Unexpected error";

    dispatch(setError({ isOpen: true, message, type: "error" }));
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};

export const asyncSetReadMessages = (channelId) => async (dispatch) => {
  dispatch(setFetching({ isFetching: true }));
  try {
    await readMessageService(channelId);
  } catch (error) {
    let message = "";
    if (error?.response?.data) {
      message = error.response.data.errors.length
        ? error.response.data.errors.toString()
        : error.response.data.warnings.toString();
    } else message = "Unexpected error";

    dispatch(setError({ isOpen: true, message, type: "error" }));
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};
